import { route_path } from '@app/utils/route_path';
import { useTranslation } from '@app/app/i18n';

// Функция для получения навигационных ссылок с переводами
export const useNavLinks = () => {
  const { t } = useTranslation('header');
  return [
    { id: 1, to: route_path.features, title: t('nav.features') },
    { id: 2, to: route_path.templates, title: t('nav.templates') },
    { id: 3, to: route_path.pricing, title: t('nav.pricing') },
    { id: 4, to: route_path.about, title: t('nav.about') },
  ];
};

export const useNavLinksV2 = () => {
  const { t } = useTranslation('header');
  return [
    { id: 1, to: route_path.features, title: t('nav.features') },
    { id: 2, to: route_path.templates, title: t('nav.templates') },
    { id: 3, to: route_path.about, title: t('nav.about') },
  ];
};
